import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';

@Directive({
  selector: "[customTooltip]"
})
export class CustomTooltipDirective implements OnDestroy {
  @Input() customTooltip: string | TemplateRef<any> = ""; // The text for the tooltip to display
  @Input() delay? = 1; // Optional delay input, in ms
  @Input() classes: string;

  private myPopup;
  private timer;

  constructor(private el: ElementRef, private viewContainerRef: ViewContainerRef) {}

  ngOnDestroy(): void {
    if (this.myPopup) {
      this.myPopup.remove();
    }
  }

  @HostListener("mouseenter") onMouseEnter() {
    const x = this.el.nativeElement.getBoundingClientRect().left + this.el.nativeElement.offsetWidth / 2; // Get the middle of the element
    const y = this.el.nativeElement.getBoundingClientRect().top + this.el.nativeElement.offsetHeight + 6; // Get the bottom of the element, plus a little extra
    this.createTooltipPopup(x, y);

  }

  @HostListener("mouseleave") onMouseLeave() {
    if (this.timer) clearTimeout(this.timer);
    if (this.myPopup) {
      this.myPopup.remove();
    }
  }

  private createTooltipPopup(x: number, y: number) {
    const popup = document.createElement("div");

    if (typeof this.customTooltip === 'string') {
      popup.innerHTML = this.customTooltip;
    } else if (this.customTooltip instanceof TemplateRef) {
      this.viewContainerRef.clear();
      const viewRef = this.viewContainerRef.createEmbeddedView(this.customTooltip);
      popup.appendChild(viewRef.rootNodes[0]);
    }

    const classes = this.classes ? this.classes + " tooltip-container" : 'tooltip-container';
    popup.style.position = "absolute";

    popup.setAttribute("class", classes);
    popup.style.top = y.toString() + "px";
    popup.style.left = x.toString() + "px";


    document.body.appendChild(popup);
    this.myPopup = popup;
  }


}
